export const baseUrl = process.env.NODE_ENV === 'production' ? '/api' : 'https://localhost:5001/api'//'http://192.168.1.90:5000/api'

export const productEnvironment = process.env.VUE_APP_PRODUCT_ENVIRONMENT === 'sway' ? 'sway' : 'readycheck'
